import React, { useState } from "react";
import { createSubscriber } from "../../services/FrontService";
import { notify } from "../Common/Alerts";
import Utils from "../../utils";
import { decryptData } from "../../utils/crypto";
import { Link } from "react-router-dom";

const FrontFooter = () => {
  const currentYear = new Date().getFullYear();

  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const validateForm = (email) => {
    const errors = {};

    if (!email.trim()) {
      errors.email = "Email is required";
    } else {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email)) {
        errors.email = "Please enter a valid email";
      }
    }

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm(email);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setIsLoading(true);

    let obj = {
      email: email,
    };

    createSubscriber(obj)
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        notify.success(decrypted.message);
        setEmail("");
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        notify.error(Utils.getErrorMessage(error));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div>
      <footer className="bg-brand-body border-t border-gray-200/60 pt-16 pb-8 px-6 md:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <div className="bg-brand-orange p-1.5 rounded-lg shadow-sm">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </div>
                <span className="text-xl font-extrabold text-brand-dark">
                  Dukaan<span className="text-brand-orange">Setu</span>
                </span>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed">
                Empowering Indian shopkeepers to grow their business digitally.
                Simple, fast, and built for Bharat.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-brand-dark mb-4">Support</h4>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>
                  {/* <a
                    href="/privacy-policy"
                    className="hover:text-brand-orange transition-colors"
                  >
                    Privacy Policy
                  </a> */}

                  <Link
                    to="/privacy-policy"
                    className="hover:text-brand-orange transition-colors"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms-conditions"
                    className="hover:text-brand-orange transition-colors"
                  >
                    Terms of Service
                  </Link>
                  
                </li>
                <li>
                  <Link
                    to="/contact-us"
                    className="hover:text-brand-orange transition-colors"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            <div className="space-y-4">
              <h4 className="font-bold text-brand-dark mb-4">
                Join the community
              </h4>
              <p className="text-xs text-gray-500">
                Subscribe for tips on growing your digital store.
              </p>
              <form onSubmit={handleSubmit} className="w-full max-w-sm">
                <div className="flex items-start gap-2">
                  <div className="flex flex-col flex-1">
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="text"
                      placeholder="Email"
                      className={`bg-white border ${
                        errors.email ? "border-red-500" : "border-gray-200"
                      } px-4 py-2.5 rounded-xl text-sm w-full focus:outline-none focus:border-brand-orange transition-all`}
                    />

                    {errors.email && (
                      <p className="text-red-500 text-[11px] font-bold mt-1.5 ml-1 animate-text-pop">
                        {errors.email}
                      </p>
                    )}
                  </div>

                  <button
                    type="submit"
                    disabled={isLoading}
                    className="bg-brand-gradient text-white p-3 rounded-xl shadow-lg shadow-orange-100 hover:brightness-110 disabled:opacity-60 flex items-center justify-center transition-all active:scale-95"
                  >
                    {isLoading ? (
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    ) : (
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2.5"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        />
                      </svg>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="border-t border-gray-200/60 pt-8 mt-auto">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center">
              <p className="text-xs font-medium text-gray-400 order-2 md:order-1">
                © {new Date().getFullYear()} DukaanSetu. All rights reserved. 🇮🇳
              </p>

              <div className="order-1 md:order-2">
                <a
                  href="https://waytoweb.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-slate-50 border border-slate-100 hover:border-brand-orange/30 hover:bg-orange-50/50 transition-all duration-300 shadow-sm hover:shadow-md"
                >
                  <span className="text-[10px] uppercase tracking-widest text-gray-400 font-bold group-hover:text-gray-500">
                    Powered by
                  </span>
                  <span className="text-sm font-black text-brand-navy group-hover:text-brand-orange transition-colors">
                    WayToWeb
                  </span>

                  <div className="overflow-hidden w-0 group-hover:w-4 transition-all duration-300 ease-out">
                    <svg
                      className="w-3.5 h-3.5 text-brand-orange transform -rotate-45"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </div>

                  <div className="absolute inset-x-0 -bottom-px h-px bg-gradient-to-r from-transparent via-brand-orange/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FrontFooter;
